import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = () => {
  const quickActions = [
    {
      id: 1,
      title: 'Tijd Registreren',
      description: 'Log uw gewerkte uren',
      icon: 'Clock',
      color: 'accent',
      action: 'time-tracking'
    },
    {
      id: 2,
      title: 'Opdracht Voltooien',
      description: 'Markeer werk als voltooid',
      icon: 'CheckCircle',
      color: 'success',
      action: 'complete-job'
    },
    {
      id: 3,
      title: 'Client Contacteren',
      description: 'Stuur een bericht',
      icon: 'MessageSquare',
      color: 'primary',
      action: 'contact-client'
    },
    {
      id: 4,
      title: 'Nieuwe Opdrachten',
      description: 'Bekijk beschikbare werk',
      icon: 'Search',
      color: 'secondary',
      link: '/contractor-job-browser'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      accent: 'bg-accent/10 text-accent border-accent/20 hover:bg-accent/20',
      success: 'bg-success/10 text-success border-success/20 hover:bg-success/20',
      primary: 'bg-primary/10 text-primary border-primary/20 hover:bg-primary/20',
      secondary: 'bg-secondary/10 text-secondary border-secondary/20 hover:bg-secondary/20'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  const handleAction = (action) => {
    console.log(`Action triggered: ${action}`);
  };

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Zap" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Snelle Acties
          </h3>
          <p className="caption text-muted-foreground">
            Veelgebruikte functies
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {quickActions?.map((action) => (
          action?.link ? (
            <Link
              key={action?.id}
              to={action?.link}
              className={`
                flex items-center gap-3 p-4 rounded-lg border transition-smooth
                ${getColorClasses(action?.color)}
              `}
            >
              <div className="flex-shrink-0">
                <Icon name={action?.icon} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm md:text-base text-foreground line-clamp-1">
                  {action?.title}
                </p>
                <p className="caption text-muted-foreground line-clamp-1">
                  {action?.description}
                </p>
              </div>
              <Icon name="ChevronRight" size={20} className="flex-shrink-0" />
            </Link>
          ) : (
            <button
              key={action?.id}
              onClick={() => handleAction(action?.action)}
              className={`
                flex items-center gap-3 p-4 rounded-lg border transition-smooth text-left
                ${getColorClasses(action?.color)}
              `}
            >
              <div className="flex-shrink-0">
                <Icon name={action?.icon} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm md:text-base text-foreground line-clamp-1">
                  {action?.title}
                </p>
                <p className="caption text-muted-foreground line-clamp-1">
                  {action?.description}
                </p>
              </div>
              <Icon name="ChevronRight" size={20} className="flex-shrink-0" />
            </button>
          )
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between mb-4">
          <h4 className="font-medium text-sm md:text-base text-foreground">
            Affiliate Netwerk
          </h4>
          <Icon name="Users" size={18} color="var(--color-success)" />
        </div>

        <div className="space-y-3">
          <div className="bg-success/5 rounded-lg p-3 border border-success/20">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Building2" size={16} color="var(--color-success)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm text-foreground line-clamp-1">
                  TechPartners BV
                </p>
                <p className="caption text-success">Uw primaire affiliate partner</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-3">
              <div>
                <p className="caption text-muted-foreground">Opdrachten via</p>
                <p className="font-semibold text-sm text-foreground">12 opdrachten</p>
              </div>
              <div>
                <p className="caption text-muted-foreground">Totaal verdiend</p>
                <p className="font-semibold text-sm text-success">€4.850,00</p>
              </div>
            </div>
          </div>

          <Button variant="outline" fullWidth iconName="Eye" iconPosition="left">
            Bekijk Affiliate Details
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsPanel;